import { DiscountModal } from './DiscountModal';

export { DiscountModal };
export default DiscountModal;
